export const SIGNUP_ACTION_TYPES = {
  SET_SIGNUP_BOOL: "SET_SIGNUP_BOOL",
  SET_MOB_SIGNIN_BOOL: "SET_MOB_SIGNIN_BOOL",
};
